import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import SectionHeading from "./SectionHeading";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FaqSection = () => {
  const { lang } = useLanguage();
  const t = content[lang].faqs;

  return (
    <section id="faqs" className="relative py-24 md:py-32 bg-narwhal-panel/40 border-y border-white/5">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <SectionHeading kicker={t.kicker} title={t.title} center />
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {t.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-xl border border-white/8 bg-narwhal-dark/40 px-5 data-[state=open]:border-narwhal-teal/30"
            >
              <AccordionTrigger className="text-left text-white hover:no-underline hover:text-narwhal-teal py-5 text-base font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-narwhal-muted text-sm leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
